module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-03.29c6993b.png";